import React, { useContext, useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ProductDetailsMedia from './ProductDetailsMedia';
import ProductDetailsMain from './ProductDetailsMain';
import ProductDetailsFooter from './ProductDetailsFooter';
import CartModal from '../../cart/CartModal';
import Flex from 'components/common/Flex';
import { useParams, useNavigate } from 'react-router-dom';
import { ProductContext } from 'context/Context';
import useProduct from 'y4/hooks/useProduct';
import y from 'y4/Utils';
import { initWinXinShare } from 'y4/WeiXin';

const ProductDetails = () => {
  const { productId, corp } = useParams();
  const navigate = useNavigate();
  const {
    productsDispatch,
    productsState: { config }
  } = useContext(ProductContext);

  const [product, setProduct] = useState();
  const { loadProduct } = useProduct();
  const search = input => {
    navigate(`/${corp}/e-commerce/product/product-grid?kw=${input}`);
  };

  useEffect(() => {
    loadProduct(productId).then(rt => {
      if (rt.isOk()) {
        setProduct(rt.data);
        initWinXinShare({
          config: y.gpv(config, 'option.weixin'),
          title: rt.data.name,
          link: window.location.href,
          description: rt.data.shortDescription,
          imageUrl: rt.data.files[0]
        });
      }
    });
    y.setNavbarTopSearchBox({ placeholder: config.placeholder, search });
  }, []);

  return product ? (
    <>
      <Card className="mb-3">
        <Card.Body>
          <Row>
            <Col lg={6} className="mb-4 mb-lg-0">
              <ProductDetailsMedia product={product} />
            </Col>
            <Col lg={6} as={Flex} justifyContent="between" direction="column">
              <ProductDetailsMain
                product={product}
                productsDispatch={productsDispatch}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <ProductDetailsFooter
                product={product}
                productsDispatch={productsDispatch}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <CartModal />
    </>
  ) : (
    <></>
  );
};

export default ProductDetails;
